import { Button, Card, Intent, ProgressBar } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { IFieldProps } from "decorator-form";
import React, { useState } from "react";

import VerticalCenter from "common/fragments/VerticalCenter";
import { IUploadResponse } from "core/service/upload/IUploadService";
import { IFileUpload, IUploadFieldOptions, UploadField } from "./UploadField";
import styled from "styled-components";

/**
 * if you just want the file url, not the metadata
 */

const UploadBox = styled(Card)`
	padding: 0.8em !important;
	display: flex;
	align-items: center;
	margin-top: 1em;
	
	.primary {
		flex-grow: 1;
		margin: 0px 0.8em;
	}
	
	.actions:first-child {
		margin-right: 0.8em;
	}
	
	img {
		max-height: 50px;
		max-width: 100px;
	}
`;

interface IMultiUploadOptions extends IUploadFieldOptions {}

export function UploadMultiField({formData = [], onChange, ...restProps}: IFieldProps<IFileUpload[]> & { options?: IMultiUploadOptions}) {
	const [progress, setProgress] = useState(0);

	return (
		<React.Fragment>
			<UploadField
				{...restProps}
				onChange={(o) => {
					setProgress(0);
					onChange([...formData, o]);
				}}
				options={{
					urlEditable: false,
					showPreview: false,
					onProgress: (p) => setProgress(calculateProgress(p))
				}}
				formData={null}
			/>
			{progress > 0 && (
				<ProgressBar intent={Intent.PRIMARY} value={progress / 100} />
			)}
			{renderPreview(formData, (url) =>
				onChange([...formData.filter((u) => u.url !== url)])
			)}
		</React.Fragment>
	);
}

const calculateProgress = (e) => {
	console.log(e);
	if (e.lengthComputable) {
		return (e.loaded / e.total) * 100;
	}
	return 0;
};

const renderPreview = (uploads: IUploadResponse[], onRemove: (url) => void) => {

	return uploads.map((u) => {
		return (
			<UploadBox key={u.url}>
				{u.type && u.type.startsWith('image') && (
					<VerticalCenter >
						<img src={u.url} />
					</VerticalCenter>
				)}
				<div className="primary">
					{(u.name && (
						<a href={u.url} target="_blank">{u.name}</a>
					)) || (
						<span>{u.url}</span>
					)}
				</div>
				<div className="actions">
					<Button
						minimal={true}
						icon={IconNames.SHARE}
						onClick={() => window.open(u.url)}
					/>
					<Button
						minimal={true}
						icon={IconNames.REMOVE}
						onClick={() => onRemove(u.url)}
					/>
				</div>
			</UploadBox>
		);
	});
};



// WEBPACK FOOTER //
// ./src/common/form/fields/upload/UploadMultiField.tsx